var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h5", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_vm.$t("sdl.gcrm.common.notice.details")))
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close"
            },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "ly-noti-wrap" }, [
          _vm.notice.noticeId
            ? _c("table", { staticClass: "table hori" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.importance")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "3" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            !Number(_vm.notice.importantYn)
                              ? _vm.$t("sdl.gcrm.common.general")
                              : _vm.$t("sdl.gcrm.common.important")
                          ) +
                          "\n              "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.platform")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getLabel({
                              labelJson: JSON.parse(
                                _vm.notice.platformCodeLabelJson
                              )
                            })
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.region")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getLabel({
                              labelJson: JSON.parse(
                                _vm.notice.regionCodeLabelJson
                              )
                            })
                          ) +
                          "\n              "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.date")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("dateFormat")(
                              _vm.notice.firstRegDatetime,
                              _vm.$t("data-format.date.ymd")
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.registrar")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.notice.firstRegrName) +
                          "\n              "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.subject")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "3" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.notice.title) +
                          "\n              "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.gcrm.common.content")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      attrs: { colspan: "3" },
                      domProps: { innerHTML: _vm._s(_vm.notice.contents) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("sdl.common.label.attachments")) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { attrs: { colspan: "3" } },
                      [
                        _c("sdl-fileuploader", {
                          ref: "fileUploader",
                          attrs: {
                            fileList: _vm.attachments,
                            downloadType: "NOTICE",
                            maxTotalSize: 1073741824,
                            modifyFlag: false,
                            useExtList: "zip|xlsx|xls|ppt|pptx"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.close")) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "200px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "auto" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "200px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "auto" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e858bc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e858bc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/NoticePopup.vue
// module id = null
// module chunks = 